var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.canClear)?_c('button',{staticClass:"btn btn-link clear-filters",attrs:{"type":"button"},on:{"click":_vm.onClear}},[_vm._v("x "+_vm._s(_vm.translate('desClearAllFilters')))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }